<template>
    <div class="saas-page message-command-page">
        <div class="saas-hero card-saas message-command-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{trans('general.home')}}</router-link>
                    <span class="px-1">/</span>
                    <router-link to="/message">{{trans('message.message')}}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('message.edit_draft')}}</span>
                </p>
                <h1 class="saas-hero__title">{{trans('message.edit_draft')}}</h1>
                <p class="message-command-hero__subtitle">{{ trans('message.draft') }} · {{ uuid }}</p>
            </div>
        </div>
        <div class="card-saas card-saas--flush saas-message-layout message-command-layout">
            <div class="row g-0">
                <message-sidebar menu="draft" :statistics="statistics"></message-sidebar>
                <div class="col saas-message-main">
                    <message-form :uuid="uuid"></message-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import messageForm from './form';
    import messageSidebar from './message-sidebar'

    export default {
        components : { messageForm,messageSidebar },
        data() {
            return {
                uuid:this.$route.params.uuid,
                statistics: {
                    sent: 0,
                    inbox: 0,
                    draft: 0,
                    trash: 0
                }
            };
        },
        mounted(){
            if(!helper.hasPermission('access-message')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('message')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            axios.post('/api/message/statistics')
                .then(response => response.data)
                .then(response => {
                    this.statistics.inbox = response.inbox;
                    this.statistics.sent = response.sent;
                    this.statistics.draft = response.draft;
                    this.statistics.trash = response.trash;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
        }
    }
</script>

<style scoped>
.message-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7ef;
    --linear-muted: #687083;
}

.message-command-hero,
.message-command-layout {
    border-color: rgba(98, 92, 246, 0.14);
    background:
        radial-gradient(circle at top right, rgba(98, 92, 246, 0.12), transparent 28rem),
        rgba(255, 255, 255, 0.94);
}

.message-command-hero__subtitle {
    margin: 0.45rem 0 0;
    color: var(--linear-muted);
    font-size: 0.875rem;
    font-weight: 600;
}

.saas-message-main {
    background: #ffffff;
}
</style>
